import React from 'react';
import { Paper, Grid, TextField, Button, Box } from '@material-ui/core';
import type { BirdsEyeViewFilters } from '../../../../_models/schedule.model';

interface FiltersPanelProps {
  filters: BirdsEyeViewFilters;
  onFilterChange: (filters: Partial<BirdsEyeViewFilters>) => void;
  onClearFilters: () => void;
}

const FiltersPanel: React.FC<FiltersPanelProps> = ({ filters, onFilterChange, onClearFilters }) => {
  return (
    <Paper
      elevation={2}
      style={{
        padding: '24px',
        borderRadius: '12px',
        background: 'var(--surface-page)',
        border: '1px solid var(--border-default)',
      }}
    >
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Start Date"
            type="date"
            value={filters.startDate || ''}
            onChange={(e) => onFilterChange({ startDate: e.target.value })}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            variant="outlined"
            size="small"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="End Date"
            type="date"
            value={filters.endDate || ''}
            onChange={(e) => onFilterChange({ endDate: e.target.value })}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
            variant="outlined"
            size="small"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            label="Status"
            select
            value={filters.status || ''}
            onChange={(e) =>
              onFilterChange({
                status: e.target.value as 'Scheduled' | 'Conducted' | 'Cancelled' | undefined,
              })
            }
            SelectProps={{
              native: true,
              style: {
                height: '40px',
              },
            }}
            InputProps={{
              style: {
                height: '40px',
              },
            }}
            fullWidth
            variant="outlined"
            size="small"
          >
            <option value="">All Statuses</option>
            <option value="Scheduled">Scheduled</option>
            <option value="Conducted">Conducted</option>
            <option value="Cancelled">Cancelled</option>
          </TextField>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            label="Instructor IDs"
            value={filters.instructorIds || ''}
            onChange={(e) => onFilterChange({ instructorIds: e.target.value })}
            placeholder="e.g., 1,2,3"
            fullWidth
            variant="outlined"
            size="small"
            helperText="Comma-separated"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <Button
            variant="contained"
            onClick={onClearFilters}
            fullWidth
            style={{
              background: 'var(--gradient-brand)',
              color: 'white',
              textTransform: 'none',
              fontWeight: 600,
              padding: '8px 16px',
            }}
          >
            Clear Filters
          </Button>
        </Grid>
      </Grid>

      <Grid container spacing={3} alignItems="center" style={{ marginTop: '8px' }}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Room IDs"
            value={filters.roomIds || ''}
            onChange={(e) => onFilterChange({ roomIds: e.target.value })}
            placeholder="e.g., 1,2,3"
            fullWidth
            variant="outlined"
            size="small"
            helperText="Comma-separated"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Shift IDs"
            value={filters.shiftIds || ''}
            onChange={(e) => onFilterChange({ shiftIds: e.target.value })}
            placeholder="e.g., 1,2,3"
            fullWidth
            variant="outlined"
            size="small"
            helperText="Comma-separated"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Centre IDs"
            value={filters.centreIds || ''}
            onChange={(e) => onFilterChange({ centreIds: e.target.value })}
            placeholder="e.g., 1,2,3"
            fullWidth
            variant="outlined"
            size="small"
            helperText="Comma-separated"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Batch IDs"
            value={filters.batchIds || ''}
            onChange={(e) => onFilterChange({ batchIds: e.target.value })}
            placeholder="e.g., 1,2,3"
            fullWidth
            variant="outlined"
            size="small"
            helperText="Comma-separated"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FiltersPanel;
